/**
 * Created by mqamhieh on 10/16/16.
 */
window.PerformanceAPI = new (function () {

    var self = this;
    var _protected = BaseAPI.call(self);
    _protected.setApiUrl(publicConfiguration.getLPMServer());

    self.getGroupStats = function (brandId, fromDate, toDate, relativeToNow, mode, filterBy) {
        var deferred = $q.defer();
        var params = {};
        params.relative_to_now = !!relativeToNow;
        params.from_date = fromDate;
        params.to_date = toDate || fromDate;
        params.mode = mode;
        params.filter_by = filterBy;

        _protected.request('groups/' + brandId + '/stats', 'GET', params).then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }
        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getGroupLaborStats = function (brandId, date, relativeToNow) {
        var deferred = $q.defer();
        var params = {};
        params.relative_to_now = !!relativeToNow;
        params.date = date;

        _protected.request('groups/' + brandId + '/stats/labor', 'GET', params).then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getForecastedGroupLaborStats = function (brandId, date, relativeToNow) {
        var deferred = $q.defer();
        var params = {};
        params.date = date;
        params.relative_to_now = !!relativeToNow;

        _protected.request('groups/' + brandId + '/stats/labor/forecast', 'GET', params).then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    //Returns a list of missed breaks
    self.getMissedBreaks = function (brandId, from, to, locationStatus) {
        var deferred = $q.defer();

        var payload = {
            from_date: from,
            to_date: to
        };

        if (locationStatus) {
            payload.location_status = locationStatus
        }

        _protected.request('brands/' + brandId + '/breaks', 'GET', payload)
            .then(function (result) {
                if(result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                }
                else {
                    deferred.reject(result.data);
                }
            }, function (err) {
                deferred.reject(err.data);
            });

        return deferred.promise;
    };

    self.getForecastedGroupStats = function (brandId, fromDate, toDate, relativeToNow, mode, filterBy) {
        var deferred = $q.defer();
        var params = {};
        params.relative_to_now = !!relativeToNow;
        params.from_date = fromDate;
        params.to_date = toDate || fromDate;
        params.mode = mode;
        params.filter_by = filterBy;

        _protected.request('groups/' + brandId + '/stats/forecast', 'GET', params).then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getForecastedGroupLaborStatsWithCategAndPos = function (brandId, fromDate, toDate, mode, filterBy) {
        var deferred = $q.defer();
        var params = {};
        params.from_date = fromDate;
        params.to_date = toDate || fromDate;
        params.mode = mode;
        params.filter_by = filterBy;

        _protected.request('groups/' + brandId + '/stats/labor/forecast/categories/positions', 'GET', params).then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getForecastedBrandLaborStatsWithCategAndPos = function (brandId, fromDate, toDate, mode, filterBy) {
        var deferred = $q.defer();
        var params = {};
        params.from_date = fromDate;
        params.to_date = toDate || fromDate;
        params.mode = mode;
        params.filter_by = filterBy;

        _protected.request('brands/' + brandId + '/stats/labor/forecast/categories/positions', 'GET', params).then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getGroupLaborStatsWithCategAndPos = function (brandId, fromDate, toDate, mode, filterBy) {
        var deferred = $q.defer();
        var params = {};
        params.from_date = fromDate;
        params.to_date = toDate || fromDate;
        params.mode = mode;
        params.filter_by = filterBy;

        _protected.request('groups/' + brandId + '/stats/labor/categories/positions', 'GET', params).then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getPensionSchema = function (brandId, payrunTypeId) {
        var deferred = $q.defer();
        _protected.request('brands/' + brandId + '/payrun_types/' + payrunTypeId + '/pensions/schemas', 'GET')
            .then(function (data) {
                if (data && data.data && data.data.data && data.data.status_code == 200) {
                    deferred.resolve(data.data.data.schemas);
                } else {
                    deferred.reject(data);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getPayRunsReport = function (brandId, payrunTypeId, payrunId, options) {
        var defer = $q.defer();
        var url = 'brands/' + brandId + '/payrun_types/' + payrunTypeId + '/payruns';
        var reportKey = options.report.key;
        var schemaId = options.schemaId;
        var params = {};

        switch (reportKey) {
            case "detailed_payimport":
                url += '/' + payrunId + '/detailed_payimport';
                break;
            case "summary_payimport":
                url += '/' + payrunId + '/summary_payimport';
                break;
            case "gross_to_net":
                params = {from_payrun_id: payrunId, to_payrun_id: payrunId};
                url += '/gross_to_net';
                break;
            case "summary":
                params = {from_payrun_id: payrunId, to_payrun_id: payrunId};
                url += '/summary';
                break;
            case "employee_break_down":
                params = {from_payrun_id: payrunId, to_payrun_id: payrunId};
                url += '/employee_break_down';
                break;
            case "employees":
                url += '/' + payrunId + '/employees';
                break;
            case "pensions_contribution":
                params = {schema_id: schemaId};
                url += '/' + payrunId + '/pensions/contribution';
                break;
        }

        _protected.request(url, 'GET', params)
            .then(function (data) {
                if (data && data.data && data.data.data && data.data.status_code == 200) {
                    switch (reportKey) {
                        case "detailed_payimport":
                            defer.resolve(data.data.data.detailed_payimport);
                            break;
                        case "summary_payimport":
                            defer.resolve(data.data.data.summary_payimport);
                            break;
                        case "gross_to_net":
                            defer.resolve(data.data.data.gross_to_net);
                            break;
                        case "summary":
                            defer.resolve(data.data.data.summary);
                            break;
                        case "employee_break_down":
                            defer.resolve(data.data.data.break_down);
                            break;
                        case "employees":
                            defer.resolve(data.data.data.employees);
                            break;
                        case "pensions_contribution":
                            defer.resolve(data.data.data.pensions_contribution);
                            break;
                    }

                } else {
                    defer.reject(data);
                }

            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getBrandLaborStatsWithCategAndPos = function (brandId, fromDate, toDate, mode, filterBy) {
        var deferred = $q.defer();
        var params = {};
        params.from_date = fromDate;
        params.to_date = toDate || fromDate;
        params.mode = mode;
        params.filter_by = filterBy;

        _protected.request('brands/' + brandId + '/stats/labor/categories/positions', 'GET', params).then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getLaborEmployeesHoursBrandStats = function(brandId, fromDate, toDate){
        var deferred = $q.defer();

        var params = {};
        params.from_date = fromDate;
        params.to_date = toDate || fromDate;
        _protected.request('brands/' + brandId + '/stats/labor/employees/hours', 'GET', params).then(function (data) {
            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getLaborEmployeesHoursForcastedBrandStats = function(brandId, fromDate, toDate){
        var deferred = $q.defer();

        var params = {};
        params.from_date = fromDate;
        params.to_date = toDate || fromDate;
        _protected.request('brands/' + brandId + '/stats/labor/employees/hours/forecast', 'GET', params).then(function (data) {
            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getBrandLaborStats = function(brandId, date, relativeToNow){
        var deferred = $q.defer();

        var params = {};
        params.relative_to_now = !!relativeToNow;
        params.date = date;
        _protected.request('brands/' + brandId + '/stats/labor', 'GET', params).then(function (data) {
            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getOvertimeReport = function(brandId, from, to){
        var deferred = $q.defer();

        var params = {
            from_date: from,
            to_date: to
        };

        _protected.request('brands/' + brandId + '/overtime/weekly', 'GET', params).then(function (data) {
            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getForecastedBrandLaborStats = function(brandId, date, relativeToNow){
        var deferred = $q.defer();

        var params = {};
        params.relative_to_now = !!relativeToNow;
        params.date = date;
        _protected.request('brands/' + brandId + '/stats/labor/forecast', 'GET', params).then(function (data) {
            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getLaborCostPerCategory = function(brandId, date){
        var deferred = $q.defer();

        var params = {};
        params.date = date;
        _protected.request('brands/' + brandId + '/stats/labor/categories', 'GET', params).then(function (data) {
            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };


    self.getBrandLabor = function (brandId, laborParams) {
        var deferred = $q.defer();

        var params = {
            types: laborParams.types,
            week: laborParams.week.format('YYYY-MM-DD')
        };

        _protected.request('brands/' + brandId + '/privileges/stats/labor/types', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    var getUsersForLaborReport = function (brandId, usersIds) {
        var defer = $q.defer();

        TeamAPI.getTeamMembers(brandId, usersIds)
            .then(function (users) {
                var usersObject = {};

                for (var i in users) {
                    var user = users[i];
                    usersObject[user.id] = user;
                }

                defer.resolve(usersObject);
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    var getGlobalLaborReportForecast = function (brandId, params) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/stats/employees/global_labor/forecast', 'GET', params)
            .then(function (response) {
                if (response && response.data && response.data.data && response.data.status_code == 200) {
                    var userIds = [];

                    for (var i in response.data.data) {
                        var forecast = response.data.data[i];
                        userIds.push(forecast.user_id);
                    }

                    if (response.data.data.length) {
                        getUsersForLaborReport(brandId, userIds)
                            .then(function (usersObject) {
                                for (var i in response.data.data) {
                                    var forecast = response.data.data[i];
                                    forecast.user = usersObject[forecast.user_id];
                                    forecast.group_code = forecast.group_code || forecast.position.code + '_' + forecast.user_id + '_' + forecast.rate;
                                    forecast.uniqueKey = forecast.group_code;
                                }

                                defer.resolve(response.data.data);
                            }, function (error) {
                                defer.reject(error);
                            });
                    } else {
                        defer.resolve([]);
                    }
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    var getGlobalLaborReportsActual = function (brandId, params) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/stats/employees/global_labor', 'GET', params)
            .then(function (response) {
                if (response && response.data && response.data.data && response.data.status_code == 200) {
                    var userIds = [];

                    for (var i in response.data.data) {
                        var forecast = response.data.data[i];
                        userIds.push(forecast.user_id);
                    }

                    if (response.data.data.length) {
                        getUsersForLaborReport(brandId, userIds)
                            .then(function (usersObject) {
                                for (var i in response.data.data) {
                                    var forecast = response.data.data[i];
                                    forecast.user = usersObject[forecast.user_id];
                                    forecast.group_code = forecast.group_code || forecast.position.code + '_' + forecast.user_id + '_' + forecast.rate;
                                    forecast.uniqueKey = forecast.group_code;
                                }

                                defer.resolve(response.data.data);
                            }, function (error) {
                                defer.reject(error);
                            });
                    } else {
                        defer.resolve([]);
                    }
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getGlobalLaborReports = function (brandId, types, fromDate, toDate) {
        fromDate = new Date(fromDate);
        toDate = new Date(toDate);

        if (!fromDate.valueOf()) {
            throw 'Start date not valid ' + fromDate.valueOf();
        }

        if (!toDate.valueOf()) {
            throw 'End date not valid ' + toDate.valueOf();
        }

        if (!brandId) {
            throw 'Brand id is required for this api';
        }

        if (!Array.isArray(types)) {
            throw 'Types is required as [ACTUAL, FORECAST]';
        }

        var fromDay = (fromDate.getDate() >= 10) ? fromDate.getDate() : ('0' + fromDate.getDate());
        var toDay = (toDate.getDate() >= 10) ? toDate.getDate() : ('0' + toDate.getDate());

        var fromMonth = ((fromDate.getMonth() + 1) >= 10) ? (fromDate.getMonth() + 1) : ('0' + (fromDate.getMonth() + 1));
        var toMonth = ((toDate.getMonth() + 1) >= 10) ? (toDate.getMonth() + 1) : ('0' + (toDate.getMonth() + 1));

        var params = {
            from_date: fromDate.getFullYear() + '-' + fromMonth + '-' + fromDay,
            to_date: toDate.getFullYear() + '-' + toMonth + '-' + toDay
        };

        var promises = {};

        if (types.indexOf('ACTUAL') > -1) {
            promises['actual'] = getGlobalLaborReportsActual(brandId, params);
        }

        if (types.indexOf('FORECAST') > -1) {
            promises['forecast'] = getGlobalLaborReportForecast(brandId, params);
        }

        return $q.all(promises);
    };

    self.exportGlobalLaborReportCSV = function (brandId, types, fromDate, toDate) {
        fromDate = new Date(fromDate);
        toDate = new Date(toDate);

        if (!fromDate.valueOf()) {
            throw 'Start date not valid ' + fromDate.valueOf();
        }

        if (!toDate.valueOf()) {
            throw 'End date not valid ' + toDate.valueOf();
        }

        if (!brandId) {
            throw 'Brand id is required for this api';
        }

        if (!Array.isArray(types)) {
            throw 'Types is required as [ACTUAL, FORECAST]';
        }

        var defer = $q.defer();

        var fromDay = (fromDate.getDate() >= 10) ? fromDate.getDate() : ('0' + fromDate.getDate());
        var toDay = (toDate.getDate() >= 10) ? toDate.getDate() : ('0' + toDate.getDate());

        var fromMonth = ((fromDate.getMonth() + 1) >= 10) ? (fromDate.getMonth() + 1) : ('0' + (fromDate.getMonth() + 1));
        var toMonth = ((toDate.getMonth() + 1) >= 10) ? (toDate.getMonth() + 1) : ('0' + (toDate.getMonth() + 1));

        var params = {
            projections: types,
            from_date: fromDate.getFullYear() + '-' + fromMonth + '-' + fromDay,
            to_date: toDate.getFullYear() + '-' + toMonth + '-' + toDay
        };

        _protected.request('brands/' + brandId + '/stats/employees/global_labor/export', 'POST', params)
            .then(function (response) {
                if (response && response.data && response.data.data && response.data.data.generated_file_url && response.data.status_code == 200) {
                    defer.resolve(response.data.data.generated_file_url);
                } else {
                    defer.reject('');
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getActualCostPeriods = function (brandId, params) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/stats/labor/periods', 'GET', params)
            .then(function (response) {
                if (response && response.data && response.data.data && response.data.status_code == 200) {
                    defer.resolve(response.data.data.periods);
                } else {
                    defer.reject(response);
                }
            }).catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getPublishedSchedulePenalties = function (brandId, weekStartDate) {
        var defer = $q.defer();

        if (!brandId) {
            throw 'Brand id is required for this api';
        }

        var params = {
            'week_date': weekStartDate.format('YYYY-MM-DD'),
        };

        _protected.request('brands/' + brandId + '/clocks/penalties/forecast', 'GET', params)
            .then(function (data) {
                if (data && data.data && data.data.data && data.data.status_code === 200) {
                    defer.resolve(data.data.data.clocks || []);
                } else {
                    defer.reject(data);
                }
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

});
